import { useLicenseController_getLocationsLicense } from '@/services/hooks';
import type { LocationsLicenseOverview } from '@/services/types';

import { type DomainQuery, useMappedQuery } from '../shared/query';

import { toLocationLicenses } from './mappers';

/** Which licences each of the client's locations holds. */
export function useGetLocationLicenses(
    clientId: number,
    options?: { enabled?: boolean }
): DomainQuery<LocationsLicenseOverview[]> {
    return useMappedQuery(
        useLicenseController_getLocationsLicense(clientId, options),
        toLocationLicenses
    );
}
